import axios from "axios";
import Errores from "@/utils/Errores";

export const ApiDirectorio = {
  obtenerInformacion: async (componente, tokenBearer) => {
    try {
      const response = await axios.get(
        API.DIRECTORIO + "parametrosGenerales/",
        {
          headers: {
            Authorization: `Bearer ${tokenBearer}`
          }
        }
      );

      if (response.data) {
        const parametros = response.data.reduce((acc, elemento) => {
          acc[elemento.llave] = elemento;
          return acc;
        }, {});

        let resultadoEtapa = "";
        if (parametros.etapa) {
          switch (parametros.etapa.valor) {
            case "0":
              resultadoEtapa = "REGISTRO_ANTICIPADO";
              break;
            case "1":
              resultadoEtapa = "POSTULACION";
              break;
            case "2":
              resultadoEtapa = "NORMAL";
              break;
            case "3":
              resultadoEtapa = "LISTA_DE_ESPERA";
              break;
            case "4":
              resultadoEtapa = "COMPLEMENTARIO";
              break;
            case "5":
              resultadoEtapa = "RESULTADO_FINAL";
              break;
          }
          return {
            parametroModoRecuperarPassword: parametros.modoRecuperarPassword,
            parametroRecaptchaHabilitado: parametros.recaptchaHabilitado,
            parametroAnioPostulacion: parametros.anioPostulacion,
            parametroAnioAdmision: parametros.anioAdmision,
            parametroInicioPostulacion: parametros.inicioPostulacion,
            parametroFinPostulacion: parametros.finPostulacion,
            parametroFechaPeriodoComplementario:
              parametros.fechaPeriodoComplementario,
            parametroFechaListaEspera: parametros.fechaListaEspera,
            parametroFechaResultadosFinales: parametros.fechaResultadosFinales,
            parametroAnioSiguiente: parametros.anioSiguiente,
            parametroAnioAnterior: parametros.anioAnterior,
            parametroAnioIndicadorCatDesempenioBasica:
              parametros.anioIndicadorCatDesempenioBasica,
            parametroAnioIndicadorCatDesempenioMedia:
              parametros.anioIndicadorCatDesempenioMedia,
            parametroAnioIndicadorCatSimceBasica:
              parametros.anioIndicadorCatSimceBasica,
            parametroAnioIndicadorCatSimceMedia:
              parametros.anioIndicadorCatSimceMedia,
            parametroAnioIndicadorCatDesarrolloBasica:
              parametros.anioIndicadorCatDesarrolloBasica,
            parametroAnioIndicadorCatDesarrolloMedia:
              parametros.anioIndicadorCatDesarrolloMedia,
            parametroMostrarVacantes: parametros.mostrarVacantes,
            parametroMostrarProcedimientosEspeciales:
              parametros.mostrarProcedimientosEspeciales,
            parametroModoEnvioCorreo: parametros.modoEnvioCorreo,
            resultadoEtapa
          };
        } else {
          console.error("Respuesta de API incorrecta");
          return null;
        }
      }
    } catch (error) {
      Errores.switchErrors(error, componente);
      console.error(
        "Error al cargar parámetros iniciales:",
        error.response || error.message || error
      );
      return null;
    }
  }
};

export default ApiDirectorio;



// WEBPACK FOOTER //
// ./src/services/ApiDirectorio.js